import "./CustomSelect.css";
import Select from "react-select";
import i18next from "i18next";
import { i18n } from "../../../i18n";
import { useInputContext } from "../Form/Form";

// Custom component for single value - adds title
const CustomSingleValue = ({ children, innerProps }) => (
  <div
    {...innerProps}
    className="react-select__single-value--custom"
    title={children}
  >
    {children}
  </div>
);

// Custom component for placeholder - adds title
const CustomPlaceholder = ({ children, innerProps }) => (
  <div {...innerProps} className="react-select__placeholder" title={children}>
    {children}
  </div>
);

export default function CustomSelect() {
  const {
    name,
    options = [],
    placeholder = "",
    onChange,
    required,
    isSearchable = false,
    disabled,
    value = null,
    noOptionsMessage = i18next.t("common:noOptions"),
    isMulti = false,
    isClearable = false,
    autoSortOptionsDisabled = false,
  } = useInputContext();

  const collator = new Intl.Collator(i18n.resolvedLanguage, {
    sensitivity: "base", // ignore accents and case for sorting
  });

  const sortAlpha = (a, b) => collator.compare(a.label, b.label);

  return (
    <div className="CustomSelect">
      <Select
        id={name}
        value={value}
        options={
          Array.isArray(options)
            ? !autoSortOptionsDisabled
              ? options.sort(sortAlpha)
              : options
            : []
        }
        onChange={(option) => onChange(option)}
        isSearchable={isSearchable}
        placeholder={placeholder}
        className="react-select-container"
        classNamePrefix="react-select"
        classNames={{ option: (props) => props.data.className }}
        components={{
          IndicatorSeparator: () => null,
          SingleValue: CustomSingleValue,
          Placeholder: CustomPlaceholder,
        }}
        unstyled
        required={required}
        autoComplete
        isDisabled={disabled}
        noOptionsMessage={() => noOptionsMessage}
        isMulti={isMulti}
        hideSelectedOptions={false}
        isClearable={isClearable}
      />
    </div>
  );
}
